module.exports = __webpack_public_path__ + "img/archere.2685aa90.jpg";